import type { EventBusPayload } from "@/modules/event-bus";

import { useTranslation } from "react-i18next";

import { isNotificationBroadcastModelDeleteAsyncFailedPayload } from "@/entities/notification-broadcast";
import { useInvalidateNotificationsDatabase } from "@/entities/notifications-database";
import { useGetSettingsNotifications } from "@/entities/settings";
import { useAppNotification } from "@/modules/app-notification";
import { useAsyncActions } from "@/modules/async-actions";

import { notifyModelDeleteAsyncActionFailed } from "./model-delete-async-action-failed.helper";

export const useModelDeleteAsyncActionFailed = () => {
  const { notify } = useAppNotification();
  const { removeDeletingState, setFailedState } = useAsyncActions();
  const { invalidateNotifications } = useInvalidateNotificationsDatabase();
  const { isBroadcastNotificationEnabled } = useGetSettingsNotifications();

  const { t } = useTranslation();

  const runAction = (payload: EventBusPayload) => {
    if (!isNotificationBroadcastModelDeleteAsyncFailedPayload(payload)) return;
    if (isBroadcastNotificationEnabled("model-deletion")) {
      notifyModelDeleteAsyncActionFailed({
        notify,
        title: t("notification:asyncDelete.description.failure"),
        payload,
      });
    }

    payload.models.forEach((model) => {
      removeDeletingState(model.type, model.id);
      setFailedState(model.type, model.id);
    });

    invalidateNotifications("*");
  };

  return { runAction };
};
